export enum NewsType {
  AnalystNote = 'Analyst Note',
  Blog = 'Blog',
  NewsAlert = 'News Alert',
  External = 'External',
}
